import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { BehaviorSubject, Observable, startWith } from 'rxjs';
import { BaseGenericInputComponent } from '../base-generic-input/base-generic-input.component';

@Component({
    selector: 'mat-generic-checkbox-input',
    templateUrl: './generic-checkbox-input.component.html',
    styleUrls: [ '../base-generic-input/base-generic-input.component.scss', './generic-checkbox-input.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: MatFormFieldControl,
            useExisting: GenericCheckboxInputComponent,
        },
    ],
})
export class GenericCheckboxInputComponent extends BaseGenericInputComponent<boolean> {

    public hover$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    public checked$: Observable<boolean>;

    constructor(
        @Optional()
        @Self()
        protected myNgControl: NgControl,
        protected myChangeDetectorRef: ChangeDetectorRef,
    ) {
        super(myChangeDetectorRef);

        if (this.myNgControl) {
            this.myNgControl.valueAccessor = this;
        }
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.checked$ = this.inputFormControl.valueChanges.pipe(startWith(this.inputFormControl.value));
    }

    public setCheckboxValue(): void {
        if (!this.inputFormControl.disabled) {
            const currentValue: boolean = this.inputFormControl.value;
            this.inputFormControl.patchValue(!currentValue);
        }
    }

}
